import { LoadState } from "../../../constants/enums";

export interface ITrialBalanceState {
  list: ITrialBalance[];
  loading: LoadState;
  totalRecords: number;
}

export interface ITrialBalance {

}


export const initialTrialBalanceState: ITrialBalanceState = {
    list: [],
    loading: LoadState.NotLoaded,
    totalRecords: 0,
}